$(() => {
  const fte_managing_contract_docs = () => {
    const no_of_contracts = parseInt($('#no-of-contracts').val().replaceAll(',', ''), 10);

    if (no_of_contracts < 101) {
      return 1;
    } else if (no_of_contracts < 501) {
      return 2;
    } else if (no_of_contracts < 2001) {
      return 3;
    } else if (no_of_contracts < 5001) {
      return 4;
    } else if (no_of_contracts < 10001) {
      return 5;
    } else if (no_of_contracts < 20001) {
      return 6;
    }

    return 7;
  };

  const run = () => {
    if ($('#fte-managing-contract-docs-overridden').val() === '0') {
      $('#fte-managing-contract-docs').val(fte_managing_contract_docs());
    }
  };

  run();

  $('#no-of-contracts').blur(() => {
    run();
  });

  $('#fte-managing-contract-docs').blur(() => {
    $('#fte-managing-contract-docs-overridden').val('1');
  });
});
